export default [ 
  {
    name: 'badges',
    path: 'badges',
    component: () => import('@/views/Badges'),
  },
]
